export const LABOR_VALIDATION_CODES = {
  DESCRIPTION_MAX: 'DESCRIPTION_MAX',
  DESCRIPTION_EMOJI_NOT_ALLOWED: 'DESCRIPTION_EMOJI_NOT_ALLOWED',
  PERIOD_START_REQUIRED: 'PERIOD_START_REQUIRED',
  PERIOD_END_REQUIRED: 'PERIOD_END_REQUIRED',
} as const;
